var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['rank-no', _vm.rankingClass]},[_vm._v(" "+_vm._s(_vm.rankNo)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }